/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { GmcError } from '@app/core/types';
import { createAction, props } from '@ngrx/store';
import { IgniteCache } from '@shared/types/common';
import { CacheName } from '../../../../../../frontend-shared/types/common';

export const caches = createAction('[Caches] Cache list', props<{ data: IgniteCache[]; clusterId: string }>());
export const loadCaches = createAction('[Caches] Load Cache list', props<{ clusterId: string }>());
export const destroyCache = createAction('[Caches] Destroy Cache', props<{ cacheName: string }>());
export const destroyCacheOk = createAction('[Caches] Destroy Cache success', props<{ notification: string }>());
export const destroyCacheErr = createAction('[Caches] Destroy Cache error', props<GmcError>());
export const rebalanceCache = createAction('[Caches] Rebalance Cache', props<{ cacheName: string }>());
export const rebalanceCacheOk = createAction('[Caches] Rebalance Cache success', props<{ notification: string }>());
export const rebalanceCacheErr = createAction('[Caches] Rebalance Cache error', props<GmcError>());
export const clearCache = createAction('[Caches] Clear Cache', props<{ cacheName: string }>());
export const clearCacheOk = createAction('[Caches] Clear Cache success', props<{ notification: string }>());
export const clearCacheErr = createAction('[Caches] Clear Cache error', props<GmcError>());
export const enableCacheStatistics = createAction(
  '[Caches] Enable Cache Statistics',
  props<{ cacheNames: string[] }>(),
);
export const enableCacheStatisticsOk = createAction(
  '[Caches] Enable Cache Statistics success',
  props<{ notification: string }>(),
);
export const enableCacheStatisticsErr = createAction('[Caches] Enable Cache Statistics error', props<GmcError>());
export const disableCacheStatistics = createAction(
  '[Caches] Disable Cache Statistics',
  props<{ cacheNames: string[] }>(),
);
export const disableCacheStatisticsOk = createAction(
  '[Caches] Disable Cache Statistics success',
  props<{ notification: string }>(),
);
export const disableCacheStatisticsErr = createAction('[Caches] Disable Cache Statistics error', props<GmcError>());
export const getCacheConfigurationErr = createAction('[Caches] Get Cache Configuration error', props<GmcError>());

export const getCachePartitionDistributionError = createAction(
  '[Caches] Get cache partition distribution error',
  props<GmcError>(),
);
export const loadCacheFromStore = createAction('[Caches] Load Cache from Cache Store', props<{ cacheName: string }>());
export const loadCacheFromStoreOk = createAction(
  '[Caches] Load Cache from Cache Store success',
  props<{ notification: string }>(),
);
export const loadCacheFromStoreErr = createAction('[Caches] Load Cache from Cache Store error', props<GmcError>());

export const resumeCacheDr = createAction('[Caches] Resume DR', props<{ cacheNames: CacheName[] }>());
export const resumeCacheDrOk = createAction('[Caches] Resume DR ok');
export const resumeCacheDrErr = createAction('[Caches] Resume DR err', props<GmcError>());

export const pauseCacheDr = createAction('[Caches] Pause DR', props<{ cacheNames: CacheName[] }>());
export const pauseCacheDrOk = createAction('[Caches] Pause DR ok');
export const pauseCacheDrErr = createAction('[Caches] Pause DR err', props<GmcError>());

export const startCacheFst = createAction('[Caches] Start cache FST', props<{ cacheNames: CacheName[] }>());
export const startCacheFstOk = createAction('[Caches] Start cache FST ok');
export const startCacheFstErr = createAction('[Caches] Start cache FST err', props<GmcError>());

export const stopCacheFst = createAction('[Caches] Stop cache FST', props<{ cacheNames: CacheName[] }>());
export const stopCacheFstOk = createAction('[Caches] Stop cache FST ok');
export const stopCacheFstErr = createAction('[Caches] Stop cache FST err', props<GmcError>());

export const navigateAndRunScanQuery = createAction(
  '[Caches] Navigate and run scan query',
  props<{ cacheName: string }>(),
);
